﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import DriverPropertyFlags from "../enums/DriverPropertyFlags";
import {DriverType} from "../enums/DriverType";
import ResidencyPropertyFlags from "../enums/ResidencyPropertyFlags";
import ResidencyUses from "../enums/ResidencyUses";
import VehiclePropertyFlags from "../enums/VehiclePropertyFlags";
import VehicleType from "../enums/VehicleType";
import {DefaultParkingCategory, ParkingCategory} from "../nominalTypes/ParkingCategory";
import {EntityProfile, InstallationByHostData} from "../types/InstallationByHostData";
import {EntityCategoryData, PermitParkingTypeData} from "../types/PermitParkingTypeData";


function getRealCategory(category?: ParkingCategory): ParkingCategory {
	return isNullOrEmpty(category) ? DefaultParkingCategory : category;
}

function getConfiguration<TType extends string | number | symbol, TFlags extends string | number | symbol>(configuration: Record<TType, Record<ParkingCategory, EntityProfile<TFlags>>>, type: TType, category?: ParkingCategory): EntityProfile<TFlags> {
	let name = getRealCategory(category);
	const configurationType = configuration[type];

	if (configurationType == null) {
		throw new Error(`No configuration found for type ${String(type)}`, {cause: configuration});
	}

	let cat = configurationType[name];

	if (cat == null) {
		name = DefaultParkingCategory;
		cat = configurationType[name];
	}

	if (cat == null) {
		throw new Error(`No ${String(type)} configuration found for category "${name}" (nor the default)`, {cause: configuration});
	}

	//copy: the configuration object is cached and shared — never write into it
	return {...cat, name};
}

export function getDriverConfiguration(installationData: InstallationByHostData, type: DriverType, category: ParkingCategory | undefined): EntityProfile<DriverPropertyFlags> {
	return getConfiguration(installationData.configuration.drivers.profiles, type, category);
}

export function getResidencyConfiguration(installationData: InstallationByHostData, uses: ResidencyUses, category: ParkingCategory | undefined): EntityProfile<ResidencyPropertyFlags> {
	return getConfiguration(installationData.configuration.residencies.profiles, uses, category);
}

export function getVehicleConfiguration(installationData: InstallationByHostData, type: VehicleType, category: ParkingCategory | undefined): EntityProfile<VehiclePropertyFlags> {
	return getConfiguration(installationData.configuration.vehicles.profiles, type, category);
}

export function getEntityCategoryData(data: PermitParkingTypeData, category: ParkingCategory | undefined): EntityCategoryData {
	if (category == null || category === DefaultParkingCategory) {
		if (data.defaultCategory) return data.defaultCategory;
		throw new Error("No customer data found for the default category");
	}

	const result = data.categories?.[category];
	if (result != null) return result;
	throw new Error(`No customer data found for category ${category}`);
}
